import { AnyAction } from 'redux';
import { ExtremwetterschutzSelbstbeteiligung, TaasTarifrisikoschluesselVHVV2 } from '@ps20/bff-models';
import { App, VhvV2Vorbelegungdaten } from '@ps20-frontend/frontend-models';
import { getDefaultExtremwetterschutzSelbstbeteiligung } from '@ps20-frontend/utils';
import { GlobalActions, PreiseStreckeErmittelt } from '@ps20-frontend/shop-integration-redux';
import { VhvActions } from '../vhvActions';
import { IAppState } from '../appState';

export const extremwetterschutzSelbstbeteiligungReducer = function (
  sectionState: ExtremwetterschutzSelbstbeteiligung = null,
  action: AnyAction,
  appState: IAppState,
): ExtremwetterschutzSelbstbeteiligung {
  switch (action.type) {
    case VhvActions.PLZ_CHANGED:
    case VhvActions.ORT_CHANGED:
    case VhvActions.STRASSE_CHANGED:
    case VhvActions.HAUSNUMMER_CHANGED:
    case VhvActions.MAP_COORDINATES_VHV_CHANGED_EINGABE:
    case VhvActions.MAP_COORDINATES_VHV_CHANGED_ANGEBOT: {
      return null;
    }
    case GlobalActions.PREISE_STRECKE_ERMITTELT: {
      const p: PreiseStreckeErmittelt = action.payload;
      const zone = p.taasResponsePayload?.elementarSB?.id;
      // Bei Beibehaltung bleibt der Vertrag unverändert: kein Default, die Shop-Tarifierung
      // löst diese Action ebenfalls aus.
      if (
        sectionState == null &&
        zone &&
        p.appId === App.VHV_V2 &&
        p.angebotsId === appState.angebotsId &&
        !appState.vertragsoptionen?.beibehalten
      ) {
        return getDefaultExtremwetterschutzSelbstbeteiligung(zone);
      }
      return sectionState;
    }
    case VhvActions.EXTREMWETTERSCHUTZ_SELBSTBETEILIGUNG_CHANGED: {
      if (appState.angebotsId === action.payload.angebotsId) {
        sectionState = action.payload.extremwetterschutzSelbstbeteiligung;
      }
      return sectionState;
    }
    case VhvActions.PRODUKT_ZUSATZOPTIONEN_VORBELEGT: {
      const vorbelegungdaten: VhvV2Vorbelegungdaten = action.payload;
      const extremwetterschutzBaustein = vorbelegungdaten?.vorvertragBausteinList?.find(
        baustein =>
          baustein?.taasTarifrisikoschluessel === TaasTarifrisikoschluesselVHVV2.ELEMENTAR,
      );
      if (extremwetterschutzBaustein?.betrag != null) {
        const mapped = betragToExtremwetterschutzSelbstbeteiligung(
          extremwetterschutzBaustein.betrag,
        );
        if (mapped != null) {
          return mapped;
        }
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};

function betragToExtremwetterschutzSelbstbeteiligung(betrag: number): ExtremwetterschutzSelbstbeteiligung | null {
  const paddedValue = String(betrag).padStart(4, '0');
  const key = `SELBSTBETEILIGUNG_${paddedValue}` as ExtremwetterschutzSelbstbeteiligung;
  return Object.values(ExtremwetterschutzSelbstbeteiligung).includes(key) ? key : null;
}
